import { inject, Injectable } from "@angular/core";
import { Translation, TranslocoLoader } from "@ngneat/transloco";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { catchError, forkJoin, map, of } from "rxjs";
import { StoreIdService } from "../core/services/store-id.service";
import { deployUrl } from "../core/utils/deploy-url";

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);
  private storeId = inject(StoreIdService).storeId;

  getTranslation(lang: string) {
    const headers = new HttpHeaders({
      'Cache-Control': 'no-cache',
      'x-fts-store': this.storeId ?? '',
      'x-fts-client': 'latte'
    });

    //here we should implement the dictionary logic
    const serverTranslation$ = of({});

    const clientTranslation$ = this.http.get<Translation>(deployUrl(`assets/i18n/${lang}.json`), {headers, params: {'v': Date.now()}}).pipe(
      catchError(error => {
        // TODO: Audit error and/or throw again so that Sentry can report it
        console.error(error);
        return of({});
      })
    );
    
    return forkJoin([serverTranslation$, clientTranslation$]).pipe(
      // Merges the 2 translation objects. Server object on top of client
      map(([server, client]) => (
        Object.assign(client, server) 
      ))
    );
  }
}
